import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TemplateFolder } from '@ps/survey-utils';

import { GetTemplatesParams, TemplateApi } from '../api/template.api';

@Injectable({ providedIn: 'root' })
export class TemplateService {
  private readonly _api = inject(TemplateApi);

  public getTemplates(
    params: GetTemplatesParams,
  ): Observable<TemplateFolder[]> {
    return this._api.getTemplates(params);
  }

  public createTemplateFolder(
    name: string,
    hasImpersonatedBuyer: boolean,
    parentFolderId?: number,
  ): Observable<TemplateFolder> {
    return this._api.createTemplateFolder(
      name,
      hasImpersonatedBuyer,
      parentFolderId,
    );
  }
}
